<template>
  <div class="answer-end">
      <div class="title">答题结束</div>
      <div class="view-score" @click="viewScore">查看分数</div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            score:0,
            comment:{
                title:'',
                content:''
            }
        }
    },
    created(){
        this.score = this.$route.query.score
        if(this.score==0){
            this.comment.title = '地核学渣'
            this.comment.content = window.localStorage.getItem('kkusername') + '不瞒你说，你的答题错误率……居然高达百分之百！不过千千千千万不要气馁，这俗话说的好，胜败乃兵家常事，大侠请重新来过～'
        }else if(this.score==20 || this.score==40){
            this.comment.title = '不及格专家'
            this.comment.content = window.localStorage.getItem('kkusername') + '你太南了，别人永远是差几分就满分，而你却就差那么一两分就及格。不过也不要失落，努力多做几道题，立个及格的Flag，指不定你就是下一个最强王者！'
        }else if(this.score==60){
            this.comment.title = '模范学童'
            this.comment.content = window.localStorage.getItem('kkusername') + '你一定是买五年模拟三年高考全套的达人，不管多辛苦多忙碌，坚持爱学习的人设从未倒下过。你是众人眼中勤奋的宝宝，是大家公认的“模范学童”。'
        }else if(this.score==80 || this.score==100){
            this.comment.title = '佛系学神'
            this.comment.content = '还真别说，'+window.localStorage.getItem('kkusername') + '你就是常年被家长们挂在嘴边的邻居的孩子，花的时间少分数却最高。典型的热爱学习颜值高，做题准确逻辑好，兴趣爱好少不了，快乐生活真真好。行了行了，知道你又在屏幕后偷着乐呢~'
        }else if(this.score==120){
            this.comment.title = '宇宙学霸'
            this.comment.content = '我滴个乖乖，'+window.localStorage.getItem('kkusername') + '你这简直逆天了呀，这么难的题目居然都做了出来，简直突破了人类极限，想不到身边居然有这样的学霸，清华北大就等着你来啦！'
        }
    },
    methods:{
        viewScore(){
            this.$router.push({path:'/result',query:{data:JSON.stringify(this.comment)}})
        }
    }
}
</script>

<style scoped>
.answer-end{
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.title{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 3rem;
    font-size: 0.35rem;
    color: black;
}
.view-score{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 4rem;
    font-size: 0.3rem;
    color: white;
    width: 2rem;
    height: 0.6rem;
    text-align: center;
    line-height: 0.6rem;
    border-radius: 0.01rem;
    background-color: seagreen;
}
</style>